module.exports = __webpack_public_path__ + "static/media/direct_msg.1a8a9606.svg";